import './App.less';
import ContactUs from './Model/ConatctUs';
import Footer from './Model/Footer';
import Header from './Model/Header';
import Testimonials from './Model/Testimonials';
import logo from './logo.jpeg'
import { useNavigate } from 'react-router-dom';
import ImageShow from './Model/ImageShow';
import LeftCard from './Model/leftSideBox';
import RightCard from './Model/RightSideBox';


function CustomBuild() {
  const navigate = useNavigate();
  const headerConfig = {
    logo,
    brand: 'Aspire Homes',
    menuItems: [
      { name: 'Home', link: '/', onClick: () => navigate('/') },
      { name: 'About', link: '/aboutus', onClick: () => navigate('/aboutus') },
      {
        name: 'Gallery',
        link: '/gallery',
        children: [
          {
            name: 'Custom Built',
            link: '/gallery/custom-built',
            onClick: () => navigate('/comingsoon')
          },
          {
            name: 'Home Design',
            link: '/gallery/home-design',
            onClick: () => navigate('/comingsoon')
          },
          {
            name: 'Knockdown Rebuilt',
            link: '/gallery/knockdown-rebuilt',
            onClick: () => navigate('/comingsoon')
          },
          {
            name: 'Townhouses',
            link: '/gallery/townhouses',
            onClick: () => navigate('/comingsoon')
          }
        ]
      },
      { name: 'Contact', link: '/contact', onClick: () => navigate('/contact') }
    ]
  };

  const des = "Building Your Dream Home: From Concept to Construction and Completion "
  const Brand = "Aspire Homes"
  return (
    <>
      <Header {...headerConfig} />
      <ImageShow image="/images/app/contact.png" title="Custom Build " des={des} />
      <LeftCard
        image="/images/app/design.png"
        header="Design and Planning"
        description={
          <>
            Ignite your imagination and take complete command of your home-building adventure.
This is more than just a construction project; it's the realization of your unique vision. We empower you with unparalleled control, allowing you to shape every aspect of your future home
          </>
        }
        description01={
          <>
           From Spark to Design: Collaborate closely from the earliest conceptualizations, transforming your dreams into tangible architectural plans. Your ideas are the foundation of everything we build.
          </>
        }
      />

      <RightCard
        image="/images/app/budget.png"
        header="Budgeting and Financing"
        description={
          <>
            <span> Informed Selections: </span> Navigate the exciting world of upgrades and finishes with confidence. We provide the insights you need to make selections that not only enhance your daily life but also add lasting value.
          </>
        }
        description01={
          <>
            <span>Secure financing </span> from a lender who specialises in construction loans or custom home financing.
          </>
        }
      />

      <LeftCard
        image="/images/app/permit.png"
        header="Permits and Approvals"
        description={
          <>
           <span>Seamless Process: </span> We expertly guide you through the process of building your dream home, ensuring a smooth and efficient process so construction can begin without delay.
          </>
        }
      />

      <RightCard
        image="/images/app/contruction.png"
        header="Construction"
        description={
          <>
           <span>Sign-Off to Your Future:  </span>  Experience the ultimate satisfaction of seeing your custom home come to life, culminating in the final sign-off.
          </>
        }
        description01={
          <>
            Invest in a home that truly reflects you. Make selections that matter for your future, today
          </>
        }
      />
      <Testimonials id="testimonials" />
      <ContactUs id="contact" />
      <Footer />
    </>
  );

};


export default CustomBuild;
